import React from "react";
var __jsx = React.createElement;
import { motion } from 'framer-motion';
import { Icon } from "@syarahtech/ui";
import { useEffect } from "react";
export default function MobileScreenView(_ref) {
  var children = _ref.children,
    onClose = _ref.onClose,
    title = _ref.title,
    _ref$icon = _ref.icon,
    icon = _ref$icon === void 0 ? null : _ref$icon;
  var closeIcon = icon ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Icon, icon)) : /*#__PURE__*/React.createElement(Icon, {
    icon: "material-symbols--arrow-forward-ios-rounded",
    width: 4,
    height: 4,
    className: "text-[#3c56d4]"
  });
  useEffect(function () {
    document.body.classList.add('overflow-hidden');
    return function () {
      document.body.classList.remove('overflow-hidden');
    };
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: "fixed inset-0 z-[999999]"
  }, /*#__PURE__*/React.createElement(motion.div, {
    initial: {
      x: '100%'
    },
    animate: {
      x: 0
    },
    exit: {
      x: '100%'
    },
    transition: {
      duration: 0.3
    },
    className: "absolute inset-0 bg-white shadow-lg overflow-y-auto"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center px-4 py-5 bg-white border-b border-b-gray-gainsboro border-solid"
  }, /*#__PURE__*/React.createElement("div", {
    className: "en:transform en:rotate-180",
    onClick: onClose
  }, closeIcon), /*#__PURE__*/React.createElement("div", {
    className: "text-base flex items-center text-primary font-bold m-auto"
  }, title), /*#__PURE__*/React.createElement("div", {
    className: "w-4 h-4"
  })), /*#__PURE__*/React.createElement("div", {
    className: "p-4 overflow-scroll relative"
  }, children)));
}